import { useCallback, useEffect, useReducer } from "react";
import {
  clearDeferredPrompt,
  getDeferredPrompt,
  isIosDevice,
  isPwaInstalled,
  markPwaInstalled,
  subscribePwaInstall,
} from "../pwa/pwa-install";

const usePwaInstall = () => {
  const [, refresh] = useReducer((count: number) => count + 1, 0);

  useEffect(() => subscribePwaInstall(refresh), []);

  const install = useCallback(async () => {
    const promptEvent = getDeferredPrompt();
    if (!promptEvent) {
      return null;
    }

    await promptEvent.prompt();
    const choice = await promptEvent.userChoice;
    clearDeferredPrompt();
    if (choice.outcome === "accepted") {
      markPwaInstalled();
    }
    return choice.outcome;
  }, []);

  return {
    isInstalled: isPwaInstalled(),
    canPrompt: Boolean(getDeferredPrompt()),
    isIos: isIosDevice(),
    install,
  };
};

export default usePwaInstall;
